import { TFunction } from "next-i18next";
import { IntroStep } from "intro.js/src/core/steps";
import { tooltipTitle } from "./htmlComponents";

const getVlpTourSteps = (
  showCreditTour: boolean,
  showTradeInTour: boolean,
  isMobile: boolean,
  t: TFunction
) => {
  const steps: Partial<IntroStep>[] = [];
  const vlpTourStepsIndex = {
    interestRateTooltip: 0,
    vehicleCardRightPayment: 1,
    tradeInInput: 2,
  };

  if (showCreditTour) {
    steps.push({
      element: ".right-payment-tooltip-tour",
      title: tooltipTitle,
      intro: t("tour_interest_rate_tooltip", { ns: "vehiclesPage" }),
    });
  }

  if (showTradeInTour) {
    steps.push({
      element: "#right-payment-vehicle-tour",
      title: tooltipTitle,
      intro: t("tour_vehicle_card_right_payment", { ns: "vehiclesPage" }),
    });

    steps.push({
      element: isMobile
        ? "#mobile-sidebar .trade-in-filter-input"
        : "#desktop-sidebar .trade-in-filter-input",
      title: tooltipTitle,
      intro: t("tour_trade_in_input", { ns: "vehiclesPage" }),
      tooltipClass: isMobile
        ? "mobile-sidebar-tooltip rightride-tour"
        : "rightride-tour",
    });

    if (!showCreditTour) {
      vlpTourStepsIndex.vehicleCardRightPayment -= 1;
      vlpTourStepsIndex.tradeInInput -= 1;
    }
  }

  return {
    steps,
    vlpTourStepsIndex,
  };
};

export default getVlpTourSteps;
